/**
 * FacebookContent zeigt eine Lister aller Posts für eine bestimmte PageId an
 * Inhalte werden direkt hier galden
 * Token und Basepath wird dazu aus dem Storage geholt
 */

import React, { useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { getFacebookFeeds } from '../../store/facebook/facebook.selector'
import { getFacebookFeedForPageInitiated } from '../../store/facebook/facebook.actions'

import { ScreenEnum, ViewEnum } from '@professocial/professocialTypes/types/commonTypes'
import { GetFacebookFeedForPageRequest } from '@3m5/sm_publish-frontend-api'
import { GetFacebookFeedResponse, NetworkType } from '@3m5/sm_publish-frontend-api'
import { FacebookPost } from '@3m5/sm_publish-frontend-api'

import { getTheme, getUser, namedRequestStatus } from '../../store/common/common.selectors'
import ImportProfessocialPost from './ImportProfessocialPost'
import { Box, Grid, Paper, Skeleton, Stack } from '@mui/material'
import { NetworkContentRootState } from '../../store/networkContentRoot.reducer'

export interface Props {
  networkPageId: string
}

const FacebookContent: React.FC<Props> = (props) => {
  const dispatch = useDispatch()

  const theme = useSelector(getTheme)
  const user = useSelector(getUser)

  const storedFacebookData: GetFacebookFeedResponse | undefined = useSelector(getFacebookFeeds)
  const dispatchGetFacebookFeeds = useCallback((params: GetFacebookFeedForPageRequest) => dispatch(getFacebookFeedForPageInitiated(params)), [dispatch])
  const statusOnFeedLoad: string | undefined = useSelector((state: NetworkContentRootState) => namedRequestStatus(state, getFacebookFeedForPageInitiated.type))

  useEffect(() => {
    handleEditFeed()
  }, [props.networkPageId])

  const handleEditFeed = () => {
    const params: GetFacebookFeedForPageRequest = {
      networkPageId: props.networkPageId,
    }
    props.networkPageId && dispatchGetFacebookFeeds(params)
  }

  return (
    <>
      {statusOnFeedLoad !== 'pending' && storedFacebookData && storedFacebookData.posts ? storedFacebookData.posts.map((post: FacebookPost, index:number) =>
        <div key={index}>
          <ImportProfessocialPost
            postConfiguration={{
              theme: theme,
              userRole: user?.userRole,
              size: ScreenEnum.xl,
              view: ViewEnum.overview,
              networkPageId: props.networkPageId,
              networkType: NetworkType.Facebook,
              facebookPost: post,
              onEditFeed: handleEditFeed
            }}
          />
        </div>,
      ) : (
        <>
          {[...Array(10)].map((x, i) =>
            <Paper key={i} sx={{ mb: 1 }}>
              <Grid container>
                <Grid xs={12} md={7} lg={8} sx={{ p: 4 }} container item>
                  <Grid item xs='auto'>
                    <Skeleton sx={{ mr: '13px' }} variant='circular' width={40} height={40} />
                  </Grid>
                  <Grid xs item>
                    <Stack
                      direction='row'
                      justifyContent={{ xs: 'center', sm: 'flex-start' }}
                    >
                      <Stack direction='column'>
                        <Skeleton width='50%' height={20} />
                        <Skeleton width={225} height={20} />
                      </Stack>
                      <Box marginLeft='auto' marginRight='20px'><Skeleton width='130px' height={20} /></Box>
                      <Box><Skeleton width='130px' height={20} /></Box>
                    </Stack>
                    <Grid xs={12} item>
                      <Skeleton sx={{ mt: 3 }} variant='rectangular' width='100%' height='300px' />
                      <Skeleton sx={{ mt: 3 }} width='100%' height={20} />
                      <Skeleton sx={{ mt: 1 }} width='90%' height={20} />
                    </Grid>
                  </Grid>
                </Grid>
                <Grid xs={12} md={5} lg={4} container item sx={{ backgroundColor: '#F9F9F9' }}>
                  <Grid sx={{ p: 4 }} xs item>
                    <Stack direction='column' spacing={2}>
                      <Skeleton width='100%' height={20} />
                      <Skeleton sx={{ mt: 3 }} variant='rectangular' width='100%' height='50px' />
                    </Stack>
                  </Grid>
                </Grid>
              </Grid>
            </Paper>,
          )}
        </>
      )}
    </>
  )
}

export default FacebookContent
